(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quote-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-quote-form]').forEach((wrapper) => {
    const params = new URLSearchParams(window.location.search);
    const product = wrapper.querySelector('[data-quote-product]');
    const sku = wrapper.querySelector('[data-quote-sku]');
    if (product && params.get('product')) product.value = params.get('product');
    if (sku && params.get('sku')) sku.value = params.get('sku');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="search"]');
        this.results = this.querySelector('[data-predictive-results]');
        this.input.addEventListener('input', () => this.search());
      }
      async search() {
        const term = this.input.value.trim();
        if (term.length < 2) { this.results.innerHTML = ''; this.input.setAttribute('aria-expanded', 'false'); return; }
        const response = await fetch(`${this.dataset.endpoint}?q=${encodeURIComponent(term)}&section_id=predictive-search&resources[type]=product&resources[limit]=6`);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
        this.results.innerHTML = html ? html.innerHTML : '';
        this.input.setAttribute('aria-expanded', html ? 'true' : 'false');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
